import { Day } from './time'
import { Address } from './types/business'

export const getMinDay = (interimDate: string) => Day.fromYmd(interimDate).addDays(1)
export const getMinDayYmd = (interimDate: string) => getMinDay(interimDate).ymd()

export const addressToString = ({ street, city, postcode }: Address) =>
    street + '\n' + city + ' ' + postcode
